import { openDB } from 'idb'
import type { IDBPDatabase } from 'idb'

export class IDBHelper {
	async openCookieDB() {
		return openDB('BUYANDSHIP_REVAMP', 1, {
			upgrade(db: IDBPDatabase) {
				db.createObjectStore('CookieConsent')
			},
		})
	}
}
